import s from './SuggestedQuestions.module.css';

interface SuggestedQuestionsProps {
  questions: string[];
  onQuestionClick: (question: string) => void;
}

export function SuggestedQuestions({ questions, onQuestionClick }: SuggestedQuestionsProps) {
  if (questions.length === 0) {
    return null;
  }

  return (
    <div class={s.container} role="group" aria-label="Suggested questions">
      {questions.map((question, index) => (
        <button
          key={index}
          type="button"
          class={s.questionBubble}
          onClick={() => onQuestionClick(question)}
          style={{ animationDelay: `${index * 100}ms` }}
        >
          {question}
        </button>
      ))}
    </div>
  );
}
